import Crud from '../views/Priority/Crud'
import Entity from '../views/Priority/Add'

let routes = {
    path: '/priorities',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/priorities/add',
            name: 'NewPriority',
            component: Entity,
            meta: {
                pageTitle: 'Prioridade',
                access_nivel: ['6'],
                breadcrumb: [
                    {
                        text: 'Adicionar Prioridade',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/priorities/edit/:id?',
            name: 'EditPriority',
            component: Entity,
            meta: {
                pageTitle: 'Prioridade',
                access_nivel: ['6'],
                breadcrumb: [
                    {
                        text: 'Editar Prioridade',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/priorities',
            name: 'list-priorities',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Prioridades',
                access_nivel: ['6'],
                breadcrumb: [
                    {
                        text: 'Prioridades',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
